// Dip vs stains rail: standalone host for the buy module's stain carousel.
// Markup + classes are shared with sections/dip-pdp-buy.liquid; the play/next logic below
// mirrors DipBuyBox#initCarousel in assets/dip-buy-box.js (keep the two in step). Standalone
// element for surfaces with no DipBuyBox, the same pattern as the builder's <dip-quotes>.
class DipStains extends HTMLElement {
  connectedCallback() {
    const track = this.querySelector('.dip-vid-track');
    const next = this.querySelector('.dip-vid-next');
    next?.addEventListener('click', () => track?.scrollBy({ left: Math.round(track.clientWidth * 0.8), behavior: 'smooth' }));
    this.querySelectorAll('.dip-vid-thumb[data-video]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const src = btn.dataset.video;
        if (!src || btn.dataset.playing) return;
        const v = document.createElement('video');
        v.src = src;
        v.controls = true;
        v.autoplay = true;
        v.playsInline = true;
        v.className = 'dip-vid-el';
        btn.appendChild(v);
        btn.dataset.playing = '1';
        btn.querySelector('.dip-vid-play')?.style.setProperty('display', 'none');
      });
    });
  }
}
if (!customElements.get('dip-stains')) customElements.define('dip-stains', DipStains);
